import { makeStyles } from 'tss-react/mui';
import { colors, hideScrollbars, spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme, _params, classes) => ({
    ukUspHeaderText: Object.assign(Object.assign({}, (theme.isFlyingFlowers ? theme.typography.xxs_regular : theme.typography.xxs_bold)), { padding: '0 !important', maxWidth: 'calc(100% - 96px)', [theme.breakpoints.down('md')]: {
            maxWidth: '100%',
        }, display: '-webkit-box', overflow: 'hidden', textOverflow: 'ellipsis', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', wordWrap: 'break-word', whiteSpace: 'normal' }),
    iconText: {
        textAlign: 'center',
        maxWidth: 'calc(100% - 72px)',
        [theme.breakpoints.down('md')]: {
            maxWidth: '100%',
        },
    },
    linkWrapper: Object.assign({ textDecoration: 'underline' }, (theme.isFlyingFlowers ? theme.typography.xxs_regular : theme.typography.xxs_bold)),
    uspLink: Object.assign(Object.assign({}, (theme.isFlyingFlowers ? theme.typography.xxs_regular : theme.typography.xxs_bold)), { paddingTop: '6px' }),
    uspCommonContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down('xl')]: Object.assign({ overflowX: 'auto', whiteSpace: 'nowrap', marginRight: 0 }, hideScrollbars),
    },
    ukContainer: {
        padding: `${spacing.xs} 0  ${spacing.xs} 0 `,
        height: '60px',
        margin: 'auto',
        backgroundColor: colors.grey.grey1,
    },
    ASPIDISTRA: {
        color: colors.siteUspsBackgroundText.ASPIDISTRA,
        [`& .${classes.icon}`]: {
            color: colors.siteUspsBackgroundText.ASPIDISTRA,
        },
    },
    DEEP_ROSE: {
        color: colors.siteUspsBackgroundText.DEEP_ROSE,
        [`& .${classes.icon}`]: {
            color: colors.siteUspsBackgroundText.DEEP_ROSE,
        },
    },
    WILD_LAVENDER: {
        color: colors.siteUspsBackgroundText.WILD_LAVENDER,
        [`& .${classes.icon}`]: {
            color: colors.siteUspsBackgroundText.WILD_LAVENDER,
        },
    },
    MONARCH_BLUE: {
        color: colors.siteUspsBackgroundText.MONARCH_BLUE,
        [`& .${classes.icon}`]: {
            color: colors.siteUspsBackgroundText.MONARCH_BLUE,
        },
    },
    PINK: {
        color: colors.siteUspsBackgroundText.PINK,
        [`& .${classes.icon}`]: {
            color: colors.siteUspsBackgroundText.PINK,
        },
    },
    RED: {
        color: colors.siteUspsBackgroundText.RED,
        [`& .${classes.icon}`]: {
            color: colors.siteUspsBackgroundText.RED,
        },
    },
    PURPLE: {
        color: colors.siteUspsBackgroundText.PURPLE,
        [`& .${classes.icon}`]: {
            color: colors.siteUspsBackgroundText.PURPLE,
        },
    },
    LILAC: {
        color: colors.siteUspsBackgroundText.LILAC,
        [`& .${classes.icon}`]: {
            color: colors.siteUspsBackgroundText.LILAC,
        },
    },
    PEACH: {
        color: colors.siteUspsBackgroundText.PEACH,
        [`& .${classes.icon}`]: {
            color: colors.siteUspsBackgroundText.PEACH,
        },
    },
    YELLOW: {
        color: colors.siteUspsBackgroundText.YELLOW,
        [`& .${classes.icon}`]: {
            color: colors.siteUspsBackgroundText.YELLOW,
        },
    },
    GREEN: {
        color: colors.siteUspsBackgroundText.GREEN,
        [`& .${classes.icon}`]: {
            color: colors.siteUspsBackgroundText.GREEN,
        },
    },
    GOLD: {
        color: colors.primary.gold5,
        [`& .${classes.icon}`]: {
            color: colors.primary.gold5,
        },
    },
    BLACK: {
        color: colors.grey.grey6,
        [`& .${classes.icon}`]: {
            color: colors.supplementary.black,
        },
    },
    FF_WILD_EXOTIC: {
        color: `${colors.wildExotic[500]} !important`,
        [`& .${classes.icon}`]: {
            color: colors.wildExotic[500],
        },
    },
    FF_COBALT: {
        color: `${colors.cobalt[500]} !important`,
        [`& .${classes.icon}`]: {
            color: colors.cobalt[500],
        },
    },
    FF_JADE: {
        color: `${colors.jade[500]} !important`,
        [`& .${classes.icon}`]: {
            color: colors.jade[500],
        },
    },
    FF_BLACK: {
        color: colors.black[700],
    },
    icon: {
        display: 'flex',
        marginRight: '7px',
        fontSize: '18px',
        height: '18px !important', // Added !important to override the default height of the MuiIcon-root class
        width: '18px',
        justifyContent: 'center',
        '& .MuiIcon-root': {
            width: 'unset',
            height: 'unset',
            fontSize: '18px',
        },
        alignItems: 'center',
    },
    iconSpan: {
        '& .MuiIcon-root': {
            color: _params.iconColorStyle ? _params.iconColorStyle : 'inherit',
        },
    },
}));
export default useStyles;
